// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { Tabs, Tab } from '@mui/material';

import { ReportingTab } from '../types';
import { useReporting } from '../providers/ReportingProvider';

// COMPONENT ---------------------------------------------------------------- //

const ReportingTabs = () => {
  const { selectedTab, setSelectedTab, appointmentManagementEnabled, executiveKpisEnabled } = useReporting();

  const handleChange = (_: React.SyntheticEvent, newValue: ReportingTab) => {
    setSelectedTab(newValue);
  };

  return (
    <Tabs
      value={selectedTab}
      onChange={handleChange}
      variant='scrollable'
      scrollButtons='auto'
      aria-label='Reporting dashboard tabs'
    >
      <Tab label='Operations Overview' value='operations' />
      {appointmentManagementEnabled ? <Tab label='Appointment Usage' value='appointments' /> : null}
      {executiveKpisEnabled ? <Tab label='Executive KPIs' value='executive' /> : null}
    </Tabs>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default ReportingTabs;
